import React from "react";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export function ClientSecret(props) {
  if (props.visible) {
    return (
      <React.Fragment>
        {props.clientSecret}
        <span
          style={{
            marginLeft: "1.0em",
            position: "relative",
            top: "2px",
            verticalAlign: "middle",
          }}
          onClick={(event) => props.hideSecret()}
        >
          <VisibilityIcon fontSize="inherit" />
        </span>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        {"x".repeat(36)}
        <span
          style={{
            marginLeft: "1.0em",
            position: "relative",
            top: "2px",
            verticalAlign: "middle",
          }}
          onClick={(event) => props.showSecret()}
        >
          <VisibilityOffIcon fontSize="inherit" />
        </span>
      </React.Fragment>
    );
  }
}
